<template>
	<div class="text-input">
			<label><b>{{label}}</b></label>
			<div class="form-group">
					<select class="form-control" :placeholder="placeholder" @change="$emit('input',$event.target.value)" :aria-label="label" :disabled="disabled">
							<option :value="null" selected disabled>Select User Type</option>
							<option v-for="r in usertypes" :key="r[1]" :value="r[1]" :selected="r[1] === value">{{r[0]}}</option>
					</select>
					<i class="fa fa-chevron-down"></i>
			</div>
	</div>
</template>

<script>
	export default {
			name: "UserTypeSelect",
			props: {
				label: {
						type: String,
				},
				placeholder: {
						type: String,
				},
				value: {
						type: Number,
				},
				disabled: {
						type: Boolean,
						default: false,
				},
				usertypes: {
						type: Array, // ex: [ ['Sales Administrator', 2],  ]
				}
			},
	}
</script>

<style lang="scss" scoped>
	.form-group{
			margin-bottom: 0px;
			select {
					-webkit-appearance: none;
					-moz-appearance: none;
					-o-appearance: none;
					/* no standardized syntax available, no ie-friendly solution available */
			}
			select + i.fa {
					float: right;
					margin-top: -26px;
					margin-right: 5px;
					/* this is so when you click on the chevron, your click actually goes on the dropdown menu */
					pointer-events: none;
					/* everything after this is just to cover up the original arrow */
					/* (for browsers that don't support the syntax used above) */
					background: inherit;
					padding-right: 5px;
			}
	}
</style>

